module.exports = __webpack_public_path__ + "static/media/img5.3379e409.jpeg";